import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persistedstate'

import ModuleMyAuth from './ModuleMyAuth'

Vue.use(Vuex)

const MyStore = new Vuex.Store({
  modules: {
    MyAuth: ModuleMyAuth
  },
  plugins: [VuexPersist(
    {
      key: 'MyAuth',
      storage: window.sessionStorage
    }
  )]
})

export default MyStore
